import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import {
  setUnauthorizedHandler,
  clearUnauthorizedHandler,
} from "../utils/apiClient";

/**
 * Component that handles session timeout by listening for 401 responses
 * from the API client and logging the user out with a notification
 */
export function SessionTimeoutHandler() {
  const auth = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    // Set up the global unauthorized handler
    setUnauthorizedHandler(() => {
      // Only trigger session timeout if user is actually authenticated
      // If not authenticated, the 401 is expected (e.g., invalid login)
      if (auth.isAuthenticated()) {
        // Clear auth state
        auth.logout(() => {
          // Show toast notification
          showToast(
            "Your session has timed out. Please log in again.",
            "warning",
          );
          // Redirect to login
          navigate("/login");
        });
      }
    });

    // Clean up on unmount
    return () => {
      clearUnauthorizedHandler();
    };
  }, [auth, showToast, navigate]);

  return null; // This component doesn't render anything
}
